<h2 mat-dialog-title>Mostrar suas informações</h2>
<mat-dialog-content>

    <p class="mat-body-2">
        Encontramos algumas informações suas em bases de dados na internet relacionado a suas experiências profissionais e educionais,
        deseja usar elas no seu perfil?
    </p>

    <!-- <h3 class="mat-title">Algumas informações encontradas</h3> -->
    <mat-list>
        <ng-container *ngIf="experiences.length > 0">
            <h3 matSubheader>Experiências profissionais</h3>
            <ng-container *ngFor="let experience of experiences">
                <mat-list-item>
                    <p matLine>{{ experience.professional_name }}</p>
                    <span matLine>{{ experience.organization }}</span>
                </mat-list-item>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="educations.length > 0">
            <h3 matSubheader>Históricos educacionais</h3>
            <ng-container *ngFor="let education of educations">
                <mat-list-item>
                    <p matLine>{{ education.course_name }}</p>
                    <span matLine>{{ education.institution_name }}</span>
                </mat-list-item>
            </ng-container>
        </ng-container>
    </mat-list>

</mat-dialog-content>
<mat-progress-bar *ngIf="submiting" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button color="primary" mat-raised-button (click)="sendResponse(true)">Sim, quero usar</button>
    <button color="accent" mat-stroked-button (click)="sendResponse(false)">Não usar</button>
</mat-dialog-actions>